import * as React from 'react';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

import type {QuoteTimes} from '../../../../../../ui/lead/sales-documents/shared';

import {ActionMenu} from '../../action-menu/action-menu';
import {IconAvatar} from '../../avatar/icon-avatar';
import {colors} from '../../colors/colors';
import {InvoiceIcon} from '../../icon/svg/invoice-icon';
import {QuoteIcon} from '../../icon/svg/quote-icon';
import {StackLegacy} from '../../layout/stack/stack-legacy';
import {Link} from '../../link/link';
import type {SelectMenuOption} from '../../select-menu/select-menu';
import {TwoLine} from '../../two-line/two-line';

import {SalesDocumentStatusBadge} from './sales-document-status-badge';
import type {SalesDocumentType} from './types';

import styles from './sales-document-row.module.css';

type Props = {
    type: SalesDocumentType;
    salesDocumentTimes: QuoteTimes;
    actionMenuOptions: SelectMenuOption[];
    modalUrl: string;
    displayNumber: string;
    price: string;
    status: QuoteDisplayStatus;
    invoiceOverdueDuration?: string | null | undefined;
};

export function SalesDocumentRow(props: Props) {
    const scriptRef = React.createRef<HTMLElement>();

    return (
        <>
            <Link
                // @ts-expect-error
                id='edit-sales-document'
                href={props.modalUrl}
                variant='secondary'
                size='small'
                preventUnderline={true}
            >
                <div className={styles['sales-document-row']}>
                    <div className='flex align-center'>
                        <div className='pr-8'>
                            <IconAvatar
                                icon={props.type === 'Quote' ? QuoteIcon : InvoiceIcon}
                                avatarSize={30}
                                iconSize={16}
                                iconColor={props.type === 'Quote' ? colors.white : colors.lead}
                                backgroundColor={
                                    props.type === 'Quote' ? colors.lead : colors.greenLt
                                }
                            />
                        </div>
                        <div className={styles['sales-document-name-status-container']}>
                            <TwoLine
                                topRow={`${props.type} ${props.displayNumber}`}
                                bottomRow={`${props.price}`}
                                isBoldTopRow={true}
                            />
                            <SalesDocumentStatusBadge
                                status={props.status}
                                type={props.type}
                                salesDocumentTimes={props.salesDocumentTimes}
                                invoiceOverdueDuration={props.invoiceOverdueDuration}
                            />
                        </div>
                        <StackLegacy isHorizontal={true} spacing={0} alignCenter={true}>
                            <ActionMenu
                                size='small'
                                hasHoverBackground={true}
                                padding='less'
                                options={props.actionMenuOptions}
                            />
                        </StackLegacy>
                    </div>
                    {/* TODO: Change this to check for and display a viewedTime
                    <div className='flex align-center gap-4 align-center'>
                        <EyeIcon size={16} wrapWithDiv={false} color={colors.greyLt} />
                        <Body size='small' color='light'>
                            Viewed{' '}
                            {moment
                                .unix(props.salesDocumentTimes.createdAt)
                                .format('MMM Do, h:mm A')}
                        </Body>
                    </div>
                    */}
                </div>

                {/* @ts-expect-error */}
                <div ref={scriptRef} id='nutshell-quotes-container' />
            </Link>
        </>
    );
}
